document.addEventListener('DOMContentLoaded', function() {
  // Find the Story Banner section
  var section = document.querySelector('.sec-StoryBanner[aria-labelledby]');
  if (!section) return;

  // Get the value of aria-labelledby (the heading id)
  var headingId = section.getAttribute('aria-labelledby');
  if (!headingId) return;

  // Use the section as the parent for DOM operations
  var button = section.querySelector(`#story-banner-btn-${headingId.replace('story-banner-title-', '')}`) || section.querySelector('a.button');
  var rightMain = section.querySelector('.sec-StoryBanner__right-main');
  var left = section.querySelector('.sec-StoryBanner__left');
  if (!button || !rightMain || !left) return;

  // Store original position for desktop restore
  var originalParent = left;
  var originalNextSibling = button.nextElementSibling;

  function moveButton() {
    if (window.innerWidth <= 900) {
      if (rightMain.nextElementSibling !== button) {
        rightMain.parentNode.insertBefore(button, rightMain.nextElementSibling);
      }
    } else {
      if (button.parentNode !== originalParent) {
        if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
          originalParent.insertBefore(button, originalNextSibling);
        } else {
          originalParent.appendChild(button);
        }
      }
    }
  }

  // Debounced resize handler
  var resizeTimeout;
  function onResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(moveButton, 100);
  }

  // Use ResizeObserver if available, else fallback to resize event
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(moveButton);
    ro.observe(document.body);
  } else {
    window.addEventListener('resize', onResize);
  }

  moveButton();
});

class TextReveal extends HTMLElement {
    constructor() {
        super();
        this.lastKnownY = window.scrollY;
        this.isTicking = false;
        this.onScroll = this.onScroll.bind(this);
        this.requestTick = this.requestTick.bind(this);
        this.updateEl = this.updateEl.bind(this);
    }

    connectedCallback() {
        this.original = this.querySelector('[data-text-reveal-el="original"]');
        this.overlay = this.querySelector('[data-text-reveal-el="overlay"]');
        this.wordSelector = '[data-text-reveal-el="word"]';

        if (!this.original || !this.overlay) return;

        this.setupWords();
        setTimeout(() => this.updateEl(), 500);
        window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
    }

    setupWords() {
        const wordsArray = this.original.innerText.trim().split(/\s+/);
        let originalContent = '';
        let overlayContent = '';
        const revealClass = this.dataset.class || '';

        wordsArray.forEach(word => {
            originalContent += `<span>${word}</span> `;
            overlayContent += `<span class="${revealClass}" data-text-reveal-el="word">${word}</span> `;
        });

        this.original.innerHTML = originalContent.trim();
        this.overlay.innerHTML = overlayContent.trim();
    }

    onScroll() {
        this.lastKnownY = window.scrollY;
        this.requestTick();
    }

    requestTick() {
        if (!this.isTicking) {
            requestAnimationFrame(this.updateEl);
            this.isTicking = true;
        }
    }

    updateEl() {
        this.isTicking = false;
        this.revealText();
    }

    revealText() {
        const endOffset = window.innerWidth <= 768 ? 200 : 100;
        const offsetTop = this.getOffsetTop(this.original);
        const elementStartPoint = offsetTop - window.innerHeight / 2;
        const elementEndPoint = elementStartPoint + this.original.offsetHeight + endOffset;

        const wordEls = this.querySelectorAll(this.wordSelector);
        if (!wordEls.length) return;

        if (this.lastKnownY <= elementStartPoint) {
            wordEls.forEach(wordEl => {
                wordEl.style.setProperty('--Reveal_Amount', '0%');
            });
            return;
        }

        if (this.lastKnownY > elementEndPoint) {
            wordEls.forEach(wordEl => {
                wordEl.style.setProperty('--Reveal_Amount', '100%');
            });
            return;
        }

        const totalScroll = elementEndPoint - elementStartPoint;
        const scrollPercent = (this.lastKnownY - elementStartPoint) / totalScroll;

        wordEls.forEach((wordEl, index) => {
            const minPercent = index / wordEls.length;
            const maxPercent = (index + 1) / wordEls.length;

            if (scrollPercent >= minPercent && scrollPercent < maxPercent) {
                const wordScroll = scrollPercent - minPercent;
                const wordMax = maxPercent - minPercent;
                const progress = wordScroll / wordMax;
                const progressAmount = Math.round(progress * 1000) / 10;
                wordEl.style.setProperty('--Reveal_Amount', `${progressAmount}%`);
            } else if (scrollPercent > maxPercent) {
                wordEl.style.setProperty('--Reveal_Amount', '100%');
            } else {
                wordEl.style.setProperty('--Reveal_Amount', '0%');
            }
        });
    }

    getOffsetTop(el) {
        let offsetTop = 0;
        while (el) {
            offsetTop += el.offsetTop;
            el = el.offsetParent;
        }
        return offsetTop;
    }
}

customElements.get('text-reveal') || customElements.define('text-reveal', TextReveal);